export const selectedPin = `
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34.9243 16.6284C34.9243 8.37669 28.211 1.66669 19.961 1.66669C11.7127 1.66669 4.99933 8.37669 4.99933 16.6284C4.99933 26.6667 19.961 37.7384 19.961 37.7384C19.961 37.7384 34.9243 26.6667 34.9243 16.6284Z" fill="#151560"/>
    <path d="M26.7727 16.8328C26.7727 13.0762 23.7177 10.0212 19.961 10.0212C16.206 10.0212 13.151 13.0762 13.151 16.8328C13.151 20.5878 16.206 23.6428 19.961 23.6428C23.7177 23.6428 26.7727 20.5878 26.7727 16.8328Z" fill="#F7F7F7"/>
</svg>
`;
